
import { useEffect } from 'react'
import Select from 'react-select'
import { FinancialYearDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const FinancialYearHeaderDDL = (props) => {
    const { FinancialYear, setFinancialYear, YLable, HYear, flag, col } = props


    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const SelectedYearID = sessionStorage.getItem('year')
    const SelectedYearLabel = sessionStorage.getItem('yearLabel')

    useEffect(() => {
        const data = { UserID, token }
        dispatch(FinancialYearDDLAPI({ data }))
    }, [])

    const { FinancialYearData } = useSelector(state => state.FinancialYearDDLData)

    useEffect(() => {
        handleFinancialYearDDL()
    }, [FinancialYearData, SelectedYearID, SelectedYearLabel])



    const handleFinancialYearDDL = () => {
        // console.log(DeptDDLDataa)
        if (FinancialYearData && FinancialYearData.table && FinancialYearData.table.length > 0) {
            let list = FinancialYearData.table.map((item, index) => ({
                value: item.id,
                label: item.financialYear,
            }))
            if (flag == "DailyData") {
                if (FinancialYear?.ID > 0) {
                    setFinancialYear({
                        DDL: list,
                        ID: FinancialYear?.ID,
                        Label: FinancialYear?.Label,
                    })
                    setYear({
                        DDL: list,
                        ID: FinancialYear?.ID,
                        Label: FinancialYear?.Label,
                    })
                } else {
                    setFinancialYear({
                        DDL: list,
                        ID: list[0].value,
                        Label: list[0].label,
                    })
                    setYear({
                        DDL: list,
                        ID: list[0].value,
                        Label: list[0].label,
                    })
                }
            }
            else if (flag == 'Screen') {
                setFinancialYear({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
                setYear({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
            } else {
                setFinancialYear({
                    DDL: list,
                    // ID: 0,
                    // Label: "Select...",
                    ID: SelectedYearID ?? list[0].value,
                    Label: SelectedYearLabel ?? list[0].label,
                })
                setYear({
                    DDL: list,
                    ID: SelectedYearID ?? list[0].value,
                    Label: SelectedYearLabel ?? list[0].label,
                })
            }

        }
        else {
            setFinancialYear({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    const handleChangeYear = (e) => {
        sessionStorage.setItem('year', e.value)
        sessionStorage.setItem('yearLabel', e.label)
        setFinancialYear({ ...FinancialYear, ID: e.value, Label: e.label })
        setYear({ ...year, ID: e.value, Label: e.label })
    }

    return (
        <div className={col && col == '10' ? "form-group col-lg-11" : "form-group mx-3 col-lg-3"}>
            {/* <label className="d-block" htmlFor="NameofDepartment"><b>Financial Year :</b></label> */}
            {/* <select
                onChange={(e) => {
                    e ?
                        setFinancialYear({ ...FinancialYear, ID: e.target.value, Label: e.target.name })
                        :
                        setFinancialYear({ ...FinancialYear, ID: 0, Label: "Select..." })
                }}
                // onChange={(e)=>console.log(e.target.name)}
            >
                {
                    FinancialYear.DDL.map((item) => (
                        <option value={item.value} name={item.label}>{item.label}</option>
                    ))
                }
            </select> */}

            <Select
                // isClearable
                // isRtl={isRtl}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        //   borderColor: state.isFocused ? 'grey' : 'red',
                        borderColor: state.isFocused ? 'transparent' : 'transparent',
                        borderColor: '#878181',
                        boxShadow: 'none',
                        width: '100%'
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        color: 'black'
                    })
                }}
                components={{
                    IndicatorSeparator: () => null
                }}
                isSearchable
                maxMenuHeight={150}
                value={{ value: FinancialYear.ID, label: FinancialYear.Label }}
                onChange={(e) => {
                    e ?
                        // setFinancialYear({ ...FinancialYear, ID: e.value, Label: e.label })
                        handleChangeYear(e)
                        :
                        setFinancialYear({ ...FinancialYear, ID: 0, Label: "Select..." })

                }}
                options={FinancialYear.DDL}
            />

        </div>
    )
}